import React from "react";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { theme } from "./colors";

interface CembooThemeProviderProps {
    mode?: "light" | "dark";
    children: React.ReactNode;
}

export const CembooThemeProvider: React.FC<CembooThemeProviderProps> = ({ mode = "light", children }) => (
    <StyledThemeProvider theme={mode === "dark" ? theme.dark : theme.light}>
        {children}
    </StyledThemeProvider>
);
